import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { tokens } from '../../design-system/tokens';

/**
 * HeroBanner - Homepage hero with tagline and CTA
 * Heavy but smooth animations with stagger effect
 * Respects prefers-reduced-motion via Framer Motion's built-in support
 */
function HeroBanner() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1
      }
    }
  };

  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }
    },
  };

  const ctaAnimation = {
    hidden: { opacity: 0, scale: 0.9, y: 20 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }
    },
  };

  return (
    <section className="relative bg-gradient-to-br from-primary to-primary-light text-white py-20 md:py-32 overflow-hidden">
      <motion.div
        className="container mx-auto px-4"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="max-w-4xl mx-auto text-center">
          <motion.h1
            variants={fadeInUp}
            className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight"
          >
            Turning your business data into actionable intelligence
          </motion.h1>

          <motion.p
            variants={fadeInUp}
            className="text-xl md:text-2xl mb-8 text-blue-100"
          >
            Real Value Group delivers data-driven solutions that transform how you make decisions
          </motion.p>

          <motion.div variants={ctaAnimation}>
            <Link
              to="/services"
              className="inline-block bg-white text-primary px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-50 hover:scale-105 transition-all duration-200 focus-visible-ring shadow-lg"
            >
              Learn More
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
}

export default HeroBanner;

